import { ItemType } from 'antd/es/menu/hooks/useItems';
import { AddToCustomLayerEvent, AddToWorkspaceLayerEvent } from 'app/common/eventbus/Events';
import { MonitoredFlow } from 'app/model/client/CORE';
import Utils from 'app/common/util/Utils';
import { CustomLayerUtils, MapObjectType } from 'app/components/dashboard/network/map/Map';

export class MenuUtils {
    public static addToCustomSectionMenu(
        customFlowSections: Array<MonitoredFlow>,
        addToFlowSection: (payload: { flow: MonitoredFlow; tvsToAdd: Array<string> }) => void,
        createFlowSection: (payload: { idx?: number; section?: MonitoredFlow }) => void,
        selectedTvIds: string[],
        prefix?: string,
        callback?: (selectedTvIds: Array<string>) => void,
    ): ItemType {
        let subMenu = [];
        if (Utils.isNotExists(prefix)) prefix = '';
        if (customFlowSections) {
            subMenu = [
                ...customFlowSections.map((flow, i) => ({
                    key: `${prefix}-add-to-section-${flow.uuid}-${selectedTvIds}-${i}`,
                    onClick: () =>
                        this.addToCustomSectionMenuHandleUpdateSection(addToFlowSection, selectedTvIds, flow, callback),
                    label: `Add to: ${flow.flowName}`,
                })),
            ];
        }
        subMenu.push({ key: 'divider-1', type: 'divider' });
        subMenu.push({
            key: `${prefix}-create-custom-section-${selectedTvIds}`,
            label: 'New section',
            onClick: () => this.addToCustomSectionMenuHandleCreateSection(createFlowSection, selectedTvIds, callback),
        });
        const menu = {
            key: `${prefix}-add-to-custom-section-${selectedTvIds}`,
            label: 'Add to custom section',
            children: subMenu,
        } as ItemType;
        return menu;
    }

    private static addToCustomSectionMenuHandleUpdateSection(
        addToFlowSection: (payload: { flow: MonitoredFlow; tvsToAdd: Array<string> }) => void,
        selectedTvIds: string[],
        flow: MonitoredFlow,
        callback?: (selectedTvIds: Array<string>) => void,
    ) {
        if (callback) callback(selectedTvIds);

        addToFlowSection({ flow: flow, tvsToAdd: selectedTvIds });
    }

    private static addToCustomSectionMenuHandleCreateSection(
        createFlowSection: (payload: { idx?: number; section?: MonitoredFlow; tvIds?: string[] }) => void,
        selectedTvIds: string[],
        callback?: (selectedTvIds: Array<string>) => void,
    ) {
        if (callback) callback(selectedTvIds);

        createFlowSection({ tvIds: selectedTvIds });
    }

    public static addToMapWorkspaceLayerMenu(
        selectedTvIds: string[],
        prefix?: string,
        callback?: (selectedTvIds: Array<string>) => void,
    ): ItemType {
        return {
            key: `${prefix}-add-to-workspace-layer-${selectedTvIds}`,
            label: 'Add to workspace map',
            onClick: () => this.addToWorkspaceLayerMenuHandleUpdateSection(selectedTvIds, callback),
        } as ItemType;
    }

    public static addToCustomLayer(tvs: string[]) {
        const result = {
            label: 'Add to custom layer',
            key: 'add-to-custom-layer-menu',
            children: [
                ...CustomLayerUtils.customLayers.map(customLayer => ({
                    key: 'add-to-layer-' + customLayer.id,
                    label: `Add to: ${customLayer.label}`,
                    onClick: () => tvs.forEach(tv => AddToCustomLayerEvent.fire(customLayer, tv, MapObjectType.TV)),
                })),
            ],
        };

        if (result.children.length > 0) {
            return result;
        }
    }

    private static addToWorkspaceLayerMenuHandleUpdateSection(
        selectedTvIds: string[],
        callback?: (selectedTvIds: Array<string>) => void,
    ) {
        if (callback) callback(selectedTvIds);
        const objects = new Map<MapObjectType, Array<string>>();
        objects.set(MapObjectType.TV, selectedTvIds);
        AddToWorkspaceLayerEvent.fire(objects);
    }
}

export type MenuItemsFunction = () => ItemType[];
